// @flow
// Libs
import _some from 'lodash/some'

export default function isBooting (state: {[string]: Object}): boolean {
  if (!state.auth.isAuthenticated) {
    return state.auth.isBooting
  }
  return _some(state, 'isBooting')
}
